import { LoadScript } from "../scripts/LoadScript";

export interface TrackingProps {
  gtmId: string;
  userId?: string | null;
}

export const TrackingScript = ({ gtmId, userId }: TrackingProps) => {
  if (!gtmId) return null;

  return (
    <>
      <LoadScript
        id="gtm"
        type="text/javascript"
        suppressHydrationWarning
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtmId}');

            ${userId ? `window.dataLayer?.push({ publicUserId: "${userId}" })` : null}
          `,
        }}
      />
    </>
  );
};

export const TrackingIframe = ({ gtmId }: TrackingProps) => {
  if (!gtmId) return null;

  return (
    <noscript
      dangerouslySetInnerHTML={{
        __html: `
          <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>
        `,
      }}
    />
  );
};
